import React from 'react';
import { Link } from 'react-router';
import { Button, Dialog, label } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemAdministrative} from './datatable/list';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import {TextArea, Input, DropDown, DropDownTreeMultipleSelect} from 'components/tt-forms/common';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import {MasterLayout} from 'layout';

class Administrative extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ma: '',
      ten: '',
      parentCategory: '',
      moTa: '',
      maTTCP: '',
      categoryId: 0,
      capDonViHanhChinhID: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,
      isValid: true,
      donViHanhChinhList: [],
      capDonViHanhChinhList: [],
      donViHanhChinhFilter: [],
      capDonViHanhChinhFilter: '',
      timKiemNangCao: false
    };
  }

  componentDidMount() {
    this.getListData();
    this.getDonViHanhChinh();
    this.getCapDonViHanhChinh();
  }

  getDonViHanhChinh() {
    Danhmuc.actions.getDonViHanhChinhTimKiem.request().then(res => {
      if (res.data && res.data._embedded) {
        this.state.donViHanhChinhList = res.data._embedded.donViHanhChinhs;
        this.setState({...this.state});
      }
    });
  }

  getCapDonViHanhChinh() {
    Danhmuc.actions.getCapDonViHanhChinhTimKiem.request().then(res => {
      if (res.data && res.data._embedded) {
        this.state.capDonViHanhChinhList = res.data._embedded.capDonViHanhChinhs;
        this.setState({...this.state});
      }
    });
  }

  onChange(name, e) {
    if (name == 'donViHanhChinhFilter') {
      this.state.donViHanhChinhFilter = e;
    } else {
      this.state[name] = e.target.value;
    }
    this.setState({...this.state});
  }
  handleSearch(e) {
    e.preventDefault();
    this.state.search = true;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if (this.state.tuKhoa) {
      params.ten = this.state.tuKhoa.trim();
    }
    if (this.state.timKiemNangCao) {
      if (this.state.capDonViHanhChinhFilter) {
        params.listCapDonVis = this.state.capDonViHanhChinhFilter;
      }
      if (this.state.donViHanhChinhFilter.length) {
        let ids = [];
        this.state.donViHanhChinhFilter.map(item => {
          ids.push(item.value);
        });
        params.listDonVis = ids.join();
      }
    }
    Danhmuc.actions.getDonViHanhChinh.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.donViHanhChinhs,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if(this.checkValidate()){
      let params = {
        ma: this.state.ma.trim(),
        ten: this.state.ten.trim(),
        moTa: this.state.moTa.trim(),
        maTTCP: this.state.maTTCP.trim(),
        capDonViHanhChinh: {id: this.state.capDonViHanhChinhID}
      };
      if (this.state.parentCategory) {
        params.cha = {
          id: this.state.parentCategory.donViHanhChinhId
        };
      }
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        Danhmuc.actions.updateDonViHanhChinh.request({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false})
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        Danhmuc.actions.postDonViHanhChinh.request('',params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false})
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }
  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if(categoryId){
      this.setState({buttonLoading: true});
      Danhmuc.actions.deleteDonViHanhChinh.request({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
         this.setState({buttonLoading: false});
      }).catch(function (error) {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail,'error');
          this.setState({buttonLoading: false});
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {

    this.toggleDialog();
    this.setState({
      addType: 0,
      ma: '',
      ten: '',
      moTa: '',
      maTTCP: '',
      parentCategory: '',
      categoryId: 0,
      capDonViHanhChinhID: 0,
      isValid: true
    });
  }

  openAddMoreCategory(item) {
    this.toggleDialog();
    this.setState({
      addType:1,
      ma: '',
      ten: '',
      parentCategory: item,
      moTa: '',
      maTTCP: '',
      capDonViHanhChinhID: item.capDonViHanhChinhDVHC.capDonViHanhChinhId,
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.toggleDialog();
    this.setState({
      addType:2,
      ma: item.ma,
      ten: item.ten,
      parentCategory: item.donViHanhChinhCha,
      moTa: item.moTa,
      maTTCP: item.maTTCP,
      categoryId: item.donViHanhChinhId,
      capDonViHanhChinhID: item.capDonViHanhChinhDVHC.capDonViHanhChinhId,
      isValid: true
    });
  }

  toggleSearch(status) {
    if (status) {
      this.state.timKiemNangCao = true;
    } else {
      this.state.timKiemNangCao = false;
    }
    this.setState({...this.state});
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Đơn vị hành chính</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('DONVIHANHCHINH_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' }>
              <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
                <InputTuKhoa value={this.state.tuKhoa} onChange={ this.onChange.bind(this, 'tuKhoa') } placeholderText="Nhập từ khóa để tìm kiếm..." />
                <DropDown label="Cấp đơn vị hành chính" selectedValue={this.state.capDonViHanhChinhFilter} onChange={ this.onChange.bind(this, 'capDonViHanhChinhFilter') } options={this.state.capDonViHanhChinhList} keyName="capDonViHanhChinhId" valueName="ten" placeholder/>
                <div className="btn-wrap">
                  <Button className={`btn-green tt-search`} text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
                </div>
                {
                  this.state.timKiemNangCao?
                    <div className='clear-left'>
                      <DropDownTreeMultipleSelect className="tree-selected" label="Đơn vị hành chính" dataOptions={this.state.donViHanhChinhList} dataSelected={this.state.donViHanhChinhFilter} onChange={this.onChange.bind(this, 'donViHanhChinhFilter')} selectAllChildren={false} propertyChildren='donViHanhChinhCha' propertyParent='donViHanhChinhId'/>
                      <div className="input-group" style={{float: 'right'}}>
                        <Link className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" } onClick={ this.toggleSearch.bind(this, false) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
                      </div>
                    </div>
                  :''
                }

              </form>
              <Link className="rearch-text" onClick={ this.toggleSearch.bind(this, true) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <DataTable
              header = {header.categoryGroup.administrative}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport
              parent= {this}
              tableLoading = {this.state.tableLoading}
            >
            <RowItemAdministrative/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa đơn vị hành chính' : 'Thêm mới đơn vị hành chính'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <Input className="col-6" label="Mã" value={this.state.ma} require={true} maxLength={40} onChange={this.onChange.bind(this, 'ma')} bindValidator={this} channel="danhMuc"/>
              <Input className="col-6" label="Mã TTCP" value={this.state.maTTCP} require={false} maxLength={40} onChange={this.onChange.bind(this, 'maTTCP')} channel="danhMuc"/>
              <Input className="col-12" label="Tên" value={this.state.ten} require={true} maxLength={40} onChange={this.onChange.bind(this, 'ten')} bindValidator={this} channel="danhMuc"/>
              {this.state.parentCategory ? (
                <div className="col-12">
                  <label className="pt-label">
                   Đơn vị hành chính cha: {this.state.parentCategory.ten}
                  </label>
                </div>
              ) : null}
              <DropDown className="col-6" label="Cấp đơn vị hành chính" require = {true} selectedValue={this.state.capDonViHanhChinhID} onChange={this.onChange.bind(this, 'capDonViHanhChinhID')} bindValidator={this} channel="danhMuc" placeholder={{key: '' ,text:'Chọn...'}} options={this.state.capDonViHanhChinhList} keyName="capDonViHanhChinhId" valueName="ten"/>
              <TextArea label="Mô tả" maxLength={255} rows={5} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className='col-12'/>
            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                  <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
                </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

Administrative.defaultProps = {
  validators: {}
}


export default connect()(Administrative);



// WEBPACK FOOTER //
// ./src/components/modules/category/Administrative.jsx